<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
  >
    <template #header>
      Cambiar contraseña
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <div
      :class="[loadingForm ? 'flex' : 'hidden']"
      class="justify-content-center align-items-center h-full"
    >
      <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
    </div>

    <Form
      ref="formRef"
      v-bind="formConfigRef"
      :class="[loadingForm ? 'hidden' : 'flex']"
    />

    <template #footer>
      <div class="col-12">
        <div class="flex justify-content-between flex-wrap gap-3">
          <Button
            label="Generar contraseña segura"
            @click="handleRandomPassword"
            severity="secondary"
          />
          <Button
            label="Actualizar"
            @click="save"
            :loading="loading"
            loading-icon="pi pi-spinner"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { useToast } from "primevue/usetoast";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";
import { Form } from "@sttedra_ui/framework";

import { appUserResetUserPassword } from "@/api/users/users.api.js";
import useFormConfig from "@/pages/_root/update-password-dialog/update-password-dialog-form.view-config.js"; // eslint-disable-line
import {
  createRandomPassword,
  checkFormHasData,
  handleShowConfirm,
} from "@/composables/_commons/helper.js";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const loadingForm = ref(false);
const loading = ref(false);
const confirm = useConfirm();
const store = useStore();
const toast = useToast();
const formConfigRef = ref(null);
const showModalRef = ref(false);
const formRef = ref(null);
const email = ref("");
// #endregion

// #region Functions
// Open the modal with the data
function showModal(userEmail) {
  loadingForm.value = true;
  email.value = userEmail;
  formConfigRef.value = useFormConfig();

  // Show the modal
  showModalRef.value = true;
  loadingForm.value = false;
}

// Save the register
async function save() {
  // Validate the form
  const invalid = !(await formRef.value?.v$Ref.$validate());

  // If the form is invalid, show a error toast
  if (invalid) return;

  loading.value = true;

  const formData = formRef.value.state$$.values;

  if (formData.Password != formData.confirmPassword) {
    toast.add({
      severity: "error",
      summary: "Error de validación",
      detail: "Las contraseñas no coinciden",
      life: 3000,
    });

    loading.value = false;
    return;
  }

  // Get the data from the form
  const data = {
    email: email.value,
    contrasena: formRef.value.state$$.values.Password,
  };

  let response = await appUserResetUserPassword(data);

  // If the response is 200, show a success toast, else show a error toast
  if (response == true || response == "") {
    toast.add({
      severity: "success",
      summary: "Contraseña actualizada",
      detail: "La contraseña ha sido actualizada correctamente.",
      life: 3000,
    });

    showModalRef.value = false;
  } else {
    toast.add({
      severity: "error",
      summary: "Petición incorrecta",
      detail:
        "No se ha podido actualizar la contraseña. Por favor, inténtelo de nuevo.",
      life: 3000,
    });
  }

  loading.value = false;
}

function handleRandomPassword() {
  const newPassword = createRandomPassword();

  formRef.value.state$$.values.Password = newPassword;
  formRef.value.state$$.values.confirmPassword = newPassword;
}

function closeModal() {
  let showConfirm = false;

  if (checkFormHasData({ ...formRef.value.state$$.values })) {
    showConfirm = true;
  }

  if (showConfirm) {
    handleShowConfirm(confirm, showModalRef);
  } else {
    showModalRef.value = false;
  }
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
